import Links from "./links";
import {ModelInterface} from "../../data-structures/collection";


export default class TaskViewLinks implements ModelInterface {

    public id       : ID
    public title    : string
    public links    : Links

    constructor(data: any) {

        this.id     = _.get(data, 'id', "")
        this.title  = _.get(data, 'title', "Links")

        const links = _.get(data, 'links', [])

        this.links  = Links.initFromJSON(links)
    }

    toJSON() {
        return {
            id      : this.id,
            title   : this.title,
            links   : this.links.toJSON()
        }
    }

}
